import { v4 as uuid } from 'uuid'

export const getGA = new Promise<Record<string, string>>((resolve) => {
    const timeout = setTimeout(() => resolve({ client_id: null, session_id: null, user_id: uuid() }), 3000);

    try {
        gtag('get', process.env.REACT_APP_GA_KEY, 'client_id', (client_id) => {
            gtag('get', process.env.REACT_APP_GA_KEY, 'session_id', (session_id) => {
                clearTimeout(timeout);

                let user_id;
                try {
                    // Test localStorage access
                    localStorage.setItem('__test__', 'test');
                    localStorage.removeItem('__test__');

                    user_id = localStorage.getItem('webshop_user_id');
                    if (!user_id) {
                        user_id = uuid();
                        localStorage.setItem('webshop_user_id', user_id);
                    }
                } catch (e) {
                    user_id = uuid(); // Fallback for incognito mode
                }

                resolve({ client_id, session_id, user_id });
            });
        });
    } catch (e) {
        clearTimeout(timeout);
        resolve({ client_id: null, session_id: null, user_id: uuid() });
    }
});
